import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  prevent(e) {
    e.preventDefault();
  }
}
